import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

// Auth
import Login from "../components/Login.vue";
import AuthLayout from "../layouts/AuthLayout.vue";
import AdminLayout from '../layouts/AdminLayout.vue'
import MainDashboard from '../views/Dashboard/Dashboard.vue'
import DailyAttendance from '../views/DailyAttendance.vue'
import UserAttendance from '../views/UserAttendance.vue'
import ActivityReport from '../views/Reports/ActivityReport.vue'
import MonthlyReport from '../views/Reports/Monthly.vue'
import UserReport from '../views/Reports/UserReport.vue'
import IssueReport from '../views/Reports/IssuesReport.vue'
import Employee from '../views/Admin/Employee.vue'
import Group from '../views/Admin/Groups.vue'
import Calendar from '../views/Admin/Calendar.vue'
import Zones from '../views/Admin/Zones.vue'
import AuditTrail from '../views/Admin/AuditTrail.vue'
import NewsFeed from '../views/Admin/NewsFeed.vue'
import Approval from '../views/Admin/Approval/Approval.vue'
import EditCompany from '../views/EditCompany.vue'
import ListActivity from '../views/NewActivity.vue'
import Schedule from '../views/Admin/Schedule/Schedule.vue'
import Shifting from '../views/Admin/Shifting/Schedule.vue'
import MasterData from '../views/Admin/MasterData/MasterData.vue'
import Hierarchy from '../views/Admin/Hierarchy/Hierarchy.vue'

import LeaveBalance from '../views/Admin/Leave/Leave.vue'
import Daily from '../views/Daily/Daily.vue'
import IssueAttendance from '../views/Issue/components/Combined.vue'
import SummaryReport from '../views/Summary/SummaryCombined.vue'
import TaskAssignment from '../views/TaskAssignment/TaskAssignment.vue'
import DashboardAttendance from '../views/DashboardAttendance/DashboardAttendance'
import LiveTracking from '../views/Admin/LiveTracking/LiveTracking'

import SalaryComponent from '../views/Admin/Payroll/SalaryComponent'
import BPJSComponent from '../views/Admin/Payroll/component/BPJSComponent'
import Period from '../views/Admin/Payroll/component/Period'
import PayrollProcess from '../views/Admin/Payroll/component/PayrollProcess'
import PayrollSummary from '../views/Admin/Payroll/component/PayrollSummary'
import SupportingComponents from '../views/Admin/Payroll/component/TaxSetting'

import MaintenanceLayout from '../layouts/MaintenanceLayout'
import UserData from '../views/Maintenance/UserData'
import NewCompany from '../views/Company/index'
import CompanyData from '../views/Maintenance/CompanyData'
import CompanyConfig from '../views/Maintenance/CompanyConfigVersionTwo'
import UserAnalityc from '../views/Maintenance/UserAnalytics'
// import ManualCleansing from '../views/Maintenance/ManualCleansing'
import MaintenanceDashboard from '../views/Maintenance/Dashboard'
import CheckInHistory from '../views/Maintenance/CheckInHistory'
import UserPerCompanyHistory from '../views/Maintenance/UserPerCompanyHistory'
import Payment from '../views/Maintenance/Billing'
import NewsFeedMaster from '../views/Maintenance/NewsFeedMaster'
import PayrollAccessControl from '../views/Maintenance/PayrollAccessControll'
import Logout from './../views/logout/Logout'

import NotFound from './../views/NotFound/NotFound'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: AdminLayout,
    beforeEnter: (to, from, next) => {
      if (store.state.authenticated == false) {
        next("/login");
      } else {
        next();
      }
    },
    children: [
      {
        path: "",
        redirect: { name: "summary-report" },
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: MainDashboard,
      },
      {
        path: "daily-attendance",
        name: "daily-attendance",
        component: DailyAttendance,
      },
      {
        path: "user-attendance",
        name: "user-attendance",
        component: UserAttendance,
      },
      {
        path: "activity-report",
        name: "activity-report",
        component: ActivityReport,
      },
      {
        path: "monthly-report",
        name: "monthly-report",
        component: MonthlyReport,
      },
      // {
      //   path: "group-report",
      //   name: "group-report",
      //   component: GroupReport,
      // },
      {
        path: "user-report",
        name: "user-report",
        component: UserReport,

      },
      {
        path: "issues-report",
        name: "issues-report",
        component: IssueReport,
      },
      {
        path: "employee",
        name: "employee",
        component: Employee,
      },
      {
        path: "groups",
        name: "groups",
        component: Group,
      },
      {
        path: "calendar",
        name: "calendar",
        component: Calendar,
      },
      {
        path: "zones",
        name: "zones",
        component: Zones,
      },
      {
        path: "audit-trail",
        name: "audit-trail",
        component: AuditTrail,
      },
      {
        path: "news-feed",
        name: "news-feed",
        component: NewsFeed
      },
      {
        path: "approval",
        name: "approval",
        component: Approval,
      },
      {
        path: "edit-company",
        name: "edit-company",
        component: EditCompany,
      },
      {
        path: "company",
        name: "company",
        component: NewCompany,
        props: true
      },
      {
        path: "list-activity",
        name: "list-activity",
        component: ListActivity,
      },
      {
        path: "schedule",
        name: "schedule",
        component: Schedule,
      },
      {
        path: "shifting",
        name: "shifting",
        component: Shifting,
      },
      {
        path: "master-data",
        name: "master-data",
        component: MasterData,
      },
      {
        path: "hierarchy",
        name: "hierarchy",
        component: Hierarchy,
      },
      {
        path: "leave",
        name: "leave",
        component: LeaveBalance,
      },
      {
        path: "daily",
        name: "daily",
        component: Daily,
      },
      {
        path: "issue-attendance",
        name: "issue-attendance",
        component: IssueAttendance,
      },
      {
        path: "summary-report",
        name: "summary-report",
        component: SummaryReport,
      },
      {
        path: "task-assignment",
        name: "task-assignment",
        component: TaskAssignment,
      },
      {
        path: "dashboard-attendance",
        name: "dashboard-attendance",
        component: DashboardAttendance,
      },
      {
        path: "live-tracking",
        name: "live-tracking",
        component: LiveTracking,
      },
      {
        path: "salary-component",
        name: "salary-component",
        component: SalaryComponent,
      },
      {
        path: "bpjs",
        name: "bpjs",
        component: BPJSComponent,
      },
      {
        path: "period-setting",
        name: "period-setting",
        component: Period,
      },
      {
        path: "payroll-process",
        name: "payroll-process",
        component: PayrollProcess,
      },
      {
        path: "period",
        name: "period",
        component: Period,
      },
      {
        path: "payroll-summary",
        name: "payroll-summary",
        component: PayrollSummary,
      },
      {
        path: "supporting-components",
        name: "supporting-components",
        component: SupportingComponents,
      },
    ],
  },
  {
    path: "/maintenance",
    name: "",
    component: MaintenanceLayout,
    beforeEnter: (to, from, next) => {
      if (store.state.authenticated == false) {
        next("/login");
      } else {
        next();
      }
    },
    children: [
      {
        path: "",
        name: "maintenance",
        redirect: { name: "dashboards" },
      },
      {
        path: "user-data",
        name: "user-data",
        component: UserData,
      },
      {
        path: "company-data",
        name: "company-data",
        component: CompanyData,
      },
      {
        path: "company-config",
        name: "company-config",
        component: CompanyConfig,
      },
      {
        path: "user-analytics",
        name: "user-analytics",
        component: UserAnalityc,
      },
      // {
      //   path: "manual-cleansing",
      //   name: "manual-cleansing",
      //   component: ManualCleansing,
      // },
      {
        path: "dashboards",
        name: "dashboards",
        component: MaintenanceDashboard,
      },
      {
        path: "check-in-history",
        name: "check-in-history",
        component: CheckInHistory,
      },
      {
        path: "user-per-company-history",
        name: "user-per-company-history",
        component: UserPerCompanyHistory,
      },
      {
        path: "payment",
        name: "payment",
        component: Payment,
      },
      {
        path: "news-feed-master",
        name: "news-feed-master",
        component: NewsFeedMaster,
      },
    ],
  },
  {
    path: "/payroll-access-control",
    name: "payroll-access-control",
    component: PayrollAccessControl,
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/",
    component: AuthLayout,
    children: [
      {
        path: "login",
        component: Login,
        name: "login",
      },
    ],
  },
  {
    path: "**",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const role = store.state.role
  switch (to.name) {
    case 'news-feed':
      if (role == 0 || role == 4 || role == 2) {
        next()
      } else {
        next('/summary-report')
      }
      break
    case 'users':
    case 'groups':
    case 'calendar':
    case 'zones':
    case 'audit-trail':
    case 'edit-company':
    case 'activity-report':
      if (role == 3 || role == 4) {
        next('/summary-report')
      } else {
        next()
      }
      break
    case 'monthly-report':
    case 'user-report':
      if (role == 3) {
        next('/summary-report')
      } else {
        next()
      }
      break

    // Payroll
    case 'salary-component':
    case 'bpjs':
    case 'tax':
    case 'period-setting':
    case 'payroll-process':
    case 'payroll-summary':
      (role != 3) && store.getters.gcGetData('feature_payroll', 'is_enabled') ? next() : next('/summary-report')
      break

    default:
      if (to.path.includes('maintenance') || to.path.includes('payroll-access-control')) {
        if (role == 2) {
          next()
        } else {
          next('/summary-report')
        }
      } else {
        next()
      }
      break;
  }
})

export default router;
